import React from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import ErrorBoundary from "./ErrorBoundary";

/**
 * Route that requires the user to be authenticated.
 * Redirects to /SignIn if no auth.uid is present, preserving the
 * intended URL so the user lands there after signing in.
 */
const PrivateRoute = ({ component: Component, auth, ...rest }) => {
  const location = useLocation();
  return (
    <Route
      {...rest}
      render={(props) =>
        auth.uid ? (
          // One crashing dashboard page shows a message, not a blank app
          <ErrorBoundary resetKey={props.location.pathname}>
            <Component {...props} />
          </ErrorBoundary>
        ) : (
          <Redirect to={`/SignIn?returnUrl=${encodeURIComponent(location.pathname + location.search + location.hash)}`} />
        )
      }
    />
  );
};

const mapStateToProps = (state) => ({
  auth: state.firebase.auth,
});

export default compose(connect(mapStateToProps))(PrivateRoute);
